import script from "./contact.vue?vue&type=script&setup=true&lang=js"
export * from "./contact.vue?vue&type=script&setup=true&lang=js"

import "./contact.vue?vue&type=style&index=0&id=25bb3dd8&lang=less"
import "./contact.vue?vue&type=style&index=1&id=25bb3dd8&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25bb3dd8"]])

export default __exports__